/**
 * @description 加油包特权兑换记录
 * @author Kody
 * @date 2019-08-06
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

import IInput from './models/input';
import { IOutput } from './models/output';
interface IRes extends IListResponse<IOutput> {
    consumed_points: number;
}

export const getRedemptionRecord = (data: IInput): Promise<IRes> => {
    return fetchData(Api.GET_REDEMPTION_RECORD, data).then((res: IRes) => {
        return res.data;
    });
};
